import { render, staticRenderFns } from "./DiscountView.vue?vue&type=template&id=a466326e"
import script from "./DiscountView.vue?vue&type=script&lang=js"
export * from "./DiscountView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports